import type { FC } from 'react';

import { Typography } from 'src/app/components/Elements/Typography';
import type { PaymentCard as PaymentCardType } from 'src/app/types';

interface PaymentCardProps {
  paymentCard: PaymentCardType;
}

const PaymentCard: FC<PaymentCardProps> = ({ paymentCard: { brand, expirationDate, last4 } }) => {
  return (
    <div className="inspectlet-sensitive">
      <div>
        <Typography variant="body">{brand}</Typography>
        <Typography variant="body">•••• {last4}</Typography>
      </div>
      <Typography variant="body" color="capsuleGray50">
        Expires {expirationDate}
      </Typography>
    </div>
  );
};

export default PaymentCard;
